import React from 'react';
import styled from 'styled-components';

import { MoonLoader } from 'react-spinners';

interface LoadingScreenProps {
  color?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ color }) => {
  return (
    <Container>
      <MoonLoader color={color ? color : "#FFFFFF"} size={60} />
    </Container>
  );
};

const Container = styled.div`
  z-index: 1;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 2%;
  right: 2%;
  bottom: 2%;
  left: 2%;
`;

export default LoadingScreen;
